import { render, staticRenderFns } from "./ChecklistRevisions.vue?vue&type=template&id=aa69c9aa&"
import script from "./ChecklistRevisions.vue?vue&type=script&lang=js&"
export * from "./ChecklistRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports